/*
 * @Author: 肖玲
 * @Date: 2023-03-02 18:30:56
 * @LastEditTime: 2024-01-22 11:31:27
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: /p2ps_vip_web/src/router/butterfly-flow-system/system-settings/modules/systemSettingRouter.js
 * 系统设置路由
 */
import store from '@/store'
import { getAuthClientList } from '@/api/common'
import { getDetail } from '@/api/flowRule'
const systemSettingRouter = [
  // 流向操作
  {
    path: '/flowSystem/fs-operations',
    name: 'flowSystemOperations',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig3" */
      //   '../views/flowSystem/FlowOperations.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig3" */
        '@/views/butterfly-flow-system/system-settings/system-setting/flow-opration/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '流向操作',
    },
  },
  // 流向卸载
  {
    path: '/flowSystem/flow-delete',
    name: 'flowSystemFlowDelete',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem4" */
      //   '../views/flowSystem/FlowDelete.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem4" */
        '@/views/butterfly-flow-system/system-settings/system-setting/flow-opration/flow-unloading/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '流向卸载',
      breadcrumb: [
        {
          title: '流向操作',
          name: 'flowSystemOperations',
        },
      ],
    },
  },
  // 流向迁移
  {
    path: '/flowSystem/transfer',
    name: 'flowSystemTransfer',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig3" */
      //   '../views/flowSystem/FlowTransfer.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig3" */
        '@/views/butterfly-flow-system/system-settings/system-setting/flow-opration/flow-migration/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '流向迁移',
      breadcrumb: [
        {
          title: '流向操作',
          name: 'flowSystemOperations',
        },
      ],
    },
    beforeEnter (to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7], 1).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
  },
  // 迁移记录
  {
    path: '/flowSystem/transfer-log',
    name: 'flowSystemTransferLog',
    component: () =>
      // import(
      //   /*webpackChunkName:"FlowTransferLog" */
      //   '../views/flowSystem/FlowTransferLog.vue'
      // ),
      import(
        /*webpackChunkName:"FlowTransferLog" */
        '@/views/butterfly-flow-system/system-settings/system-setting/flow-opration/flow-migration/Record.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '迁移记录',
      breadcrumb: [
        {
          title: '流向操作',
          name: 'flowSystemOperations',
        },
        {
          title: '流向迁移',
          name: 'flowSystemTransfer',
        },
      ],
    },
  },
  // 批量提交
  {
    path: '/flowSystem/transfer-batch',
    name: 'flowSystemTransferBatch',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig4" */
      //   '../views/flowSystem/FlowTransferBatch.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        '@/views/butterfly-flow-system/system-settings/system-setting/flow-opration/flow-migration/BatchCommit.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '批量提交',
      breadcrumb: [
        {
          title: '流向操作',
          name: 'flowSystemOperations',
        },
        {
          title: '流向迁移',
          name: 'flowSystemTransfer',
        },
      ],
    },
  },
  // 批量提交 详情
  {
    path: '/flowSystem/transfer-batch-log-detail/:batch_flow_log_id',
    name: 'flowSystemTransferBatchLogDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig4" */
      //   '../views/flowSystem/FlowTransferBatchLogDetail.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        '@/views/butterfly-flow-system/system-settings/system-setting/flow-opration/flow-migration/BatchCommitDetail.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '批量提交详情',
      breadcrumb: [
        {
          title: '流向操作',
          name: 'flowSystemOperations',
        },
        {
          title: '流向迁移',
          name: 'flowSystemTransfer',
        },
        {
          title: '批量提交',
          name: 'flowSystemTransferBatch',
        },
      ],
    },
  },
  // 流向所属岗位变更
  {
    path: '/flowSystem/flow-quarters-change',
    name: 'flowSystemFlowQuartersChange',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem5" */
      //   '../views/flowSystem/FlowQuartersChange.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/system-settings/system-setting/flow-opration/change-flow-direction/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '流向所属岗位变更',
      breadcrumb: [
        {
          title: '流向操作',
          name: 'flowSystemOperations',
        },
      ],
    },
  },
  // 流向所属人员变更
  {
    path: '/flowSystem/flow-account-change',
    name: 'flowSystemFlowAccountChange',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem6" */
      //   '../views/flowSystem/FlowAccountChange.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem6" */
        '@/views/butterfly-flow-system/system-settings/system-setting/flow-opration/change-flow-person/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '流向所属人员变更',
      breadcrumb: [
        {
          title: '流向操作',
          name: 'flowSystemOperations',
        },
      ],
    },
  },
  // 流向删除
  {
    path: '/flowSystem/flow-direction-deletion',
    name: 'flowSystemFlowDirectionDeletion',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem6" */
      //   '../views/flowSystem/FlowDirectionDeletion.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem6" */
        '@/views/butterfly-flow-system/system-settings/system-setting/flow-opration/flow-delete/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '流向删除',
      breadcrumb: [
        {
          title: '流向操作',
          name: 'flowSystemOperations',
        },
      ],
    },
  },
  // 操作日志 流向系统
  {
    path: '/flowSystem/operation-log/:meta_type',
    name: 'flowSystemOperationLog',
    component: () =>
      // import(
      //   /*webpackChunkName:"bonusReturnSystemCategory" */
      //   '../views/masterDataSystem/OperationLog.vue'
      // ),
      import(
        /*webpackChunkName:"bonusReturnSystemCategory" */
        '@/views/butterfly-flow-system/system-settings/system-setting/opration-log/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '操作日志',
    },
  },
  // 流向系统
  // 系统配置
  {
    path: '/flowSystem/fs-system-config',
    name: 'flowSystemConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig1" */
      //   '../views/flowSystem/SystemConfig.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig1" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '系统配置',
    },
  },
  // 流向清洗时间配置
  {
    path: '/flowSystem/clean-time-config',
    name: 'cleanTimeConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig1" */
      //   '../views/flowSystem/CleanTimeConfig.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig1" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/flow-wash-config/wash-time/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '流向清洗时间配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 流向自定义清洗规则配置
  {
    path: '/flowSystem/client-customization-rules',
    name: 'clientCustomizationRulesPage',
    component: () =>
      // import(
      //   /*webpackChunkName:"clientCustomizationRules" */
      //   '../views/flowSystem/clientCustomizationRules/Page.vue'
      // ),
      import(
        /*webpackChunkName:"clientCustomizationRules" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/flow-wash-config/wach-rule/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '流向自定义清洗规则配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 流向自定义清洗规则配置-添加
  {
    path: '/flowSystem/client-customization-rules-add/:json',
    name: 'clientCustomizationRulesAdd',
    component: () =>
      // import(
      //   /*webpackChunkName:"clientCustomizationRules" */
      //   '../views/flowSystem/clientCustomizationRules/Edit.vue'
      // ),
      import(
        /*webpackChunkName:"clientCustomizationRules" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/flow-wash-config/wach-rule/Add.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '添加规则',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
        {
          title: '流向自定义清洗规则配置',
          name: 'clientCustomizationRulesPage',
        },
      ],
    },
  },
  // 流向自定义清洗规则配置-编辑
  {
    path: '/flowSystem/client-customization-rules-edit/:id/:json',
    name: 'clientCustomizationRulesEdit',
    component: () =>
      // import(
      //   /*webpackChunkName:"clientCustomizationRules" */
      //   '../views/flowSystem/clientCustomizationRules/Edit.vue'
      // ),
      import(
        /*webpackChunkName:"clientCustomizationRules" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/flow-wash-config/wach-rule/Edit.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '编辑规则',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
        {
          title: '流向自定义清洗规则配置',
          name: 'clientCustomizationRulesPage',
        },
      ],
    },
    beforeEnter (to, from, next) {
      getDetail(to.params.id).then((res) => {
        if (0 === res.status) {
          store.commit('setClientCustomizationRulesInfo', res.data)
        }
        next()
      })
    },
  },
  // 待入库配置
  {
    path: '/flowSystem/pending-inflow-config',
    name: 'flowSystemPendingInFlowConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig2" */
      //   '@/views/flowSystem/PendingInFlowConfig.vue'
      // ),  待删除文件
      import(
        /*webpackChunkName:"flowSystemConfig2" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/flow-wash-config/wait-store/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '待入库配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
    beforeEnter (to, from, next) {
      getDetail(to.params.id).then((res) => {
        if (0 === res.status) {
          store.commit('setClientCustomizationRulesInfo', res.data)
        }
        next()
      })
    },
  },
  // 单位非必填设置
  {
    path: '/flowSystem/not-unit-client-config',
    name: 'notUnitClientConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"clientCustomizationRules" */
      //   '../views/flowSystem/NotUnitClientConfig.vue'
      // ),
      import(
        /*webpackChunkName:"clientCustomizationRules" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/flow-wash-config/not-required/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '字段非必填设置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 流向系统-系统配置 数据处理页面查看逻辑
  {
    path: '/flowSystem/data-examine-logic',
    name: 'flowSystemDataExamineLogic',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig4" */
      //   '../views/flowSystem/DataExamineLogic.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/flow-wash-config/data-handle/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '数据处理页面配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 流向系统-系统配置 跨省份流向配置
  {
    path: '/flowSystem/provinceFlowSetting',
    name: 'flowSystemProvinceFlowSetting',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig4" */
      //   '../views/flowSystem/ProvinceFlowSetting.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/flow-wash-config/province-flow/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '跨省份流向配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },

  // 流向系统-系统配置 采集数据配置
  {
    path: '/flowSystem/provinceCollectDataSetting',
    name: 'flowSystemCollectDataSetting',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig4" */
      //   '../views/flowSystem/flowCollectData/CollectDataSetting.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig4" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/flow-wash-config/collect-data/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '采集数据配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 流向导入系统配置
  {
    path: '/flowSystem/fs-config-import-system',
    name: 'flowSystemImportTemplateConfigSystem',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig1" */
      //   '../views/flowSystem/ImportTemplateConfigSystem.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig1" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/import-config/flow-import/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '流向导入系统配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 导入模版配置
  {
    path: '/flowSystem/fs-config-import',
    name: 'flowSystemImportTemplateConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig1" */
      //   '../views/flowSystem/ImportTemplateConfig.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig1" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/import-config/modal/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '流向导入模板配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 导入模版配置-档案流向映射模版
  {
    path: '/flowSystem/flow-template',
    name: 'flowSystemFlowTemplateList',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig1" */
      //   '../views/flowSystem/flowTemplate/list.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig1" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/import-config/modal/Shineupon.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '档案流向映射模版',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
        {
          title: '导入模版配置',
          name: 'flowSystemImportTemplateConfig',
        },
      ],
    },
  },
  // 导入模版配置-档案流向映射模版-批量导入映射字段
  {
    path: '/flowSystem/flow-template/batch-import',
    name: 'flowSystemFlowTemplateBatchImport',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig1" */
      //   '../views/flowSystem/flowTemplate/BatchImport.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig1" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/import-config/modal/BatchImport.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '批量导入映射字段',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
        {
          title: '导入模版配置',
          name: 'flowSystemImportTemplateConfig',
        },
        {
          title: '档案流向映射模版',
          name: 'flowSystemFlowTemplateList',
        },
      ],
    },
  },
  // 导入模版配置-档案流向映射模版-编辑档案流向映射模版
  {
    path: '/flowSystem/flow-template-edit/:client_id',
    name: 'flowSystemFlowTemplateEdit',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig1" */
      //   '../views/flowSystem/flowTemplate/edit.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig1" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/import-config/modal/Edit.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '编辑档案流向映射模版',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
        {
          title: '导入模版配置',
          name: 'flowSystemImportTemplateConfig',
        },
        {
          title: '档案流向映射模版',
          name: 'flowSystemFlowTemplateList',
        },
      ],
    },
  },
  // 导入模版配置-导入方式设置
  {
    path: '/flowSystem/import-mode-settings',
    name: 'flowSystemImportModeSettings',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig1" */
      //   '../views/flowSystem/ImportModeSettings.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig1" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/import-config/modal/ImportMethodSet.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '导入方式设置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
        {
          title: '导入模版配置',
          name: 'flowSystemImportTemplateConfig',
        },
      ],
    },
  },
  // 别名库维护配置
  {
    path: '/flowSystem/alias-library-maintenance',
    name: 'flowSystemAliasLibraryMaintenance',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig1" */
      //   '../views/flowSystem/AliasLibraryMaintenance.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig1" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/import-config/alias-library/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '别名库维护配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 流向关账（锁定）配置
  {
    path: '/flowSystem/about-the-account',
    name: 'flowSystemAboutTheAccount',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig1" */
      //   '../views/flowSystem/AboutTheAccount.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig1" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/import-config/close-account/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '流向关账（锁定）配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 报表账期配置
  {
    path: '/flowSystem/count-time-config',
    name: 'countTimeConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig1" */
      //   '../views/flowSystem/CountTimeConfig.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig1" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/statis-config/report-account/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '报表账期配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 商业库存预警值配置
  {
    path: '/flowSystem/inventory-warning-config',
    name: 'inventoryWarningConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig2" */
      //   '../views/flowSystem/InventoryWarningConfig.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig2" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/statis-config/purchase-warning/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '商业库存预警值配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 计量单位转换
  {
    path: '/flowSystem/count-transition',
    name: 'CountTransition',
    component: () =>
      // import(
      //   /*webpackChunkName:"CountTransition" */
      //   '../views/flowSystem/CountTransition.vue'
      // ),
      import(
        /*webpackChunkName:"CountTransition" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/statis-config/unit-measurement/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '计量单位转换',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 计量单位转换设置
  {
    path: '/flowSystem/count-transition-set/:id',
    name: 'CountTransitionSet',
    component: () =>
      // import(
      //   /*webpackChunkName:"CountTransitionSet" */
      //   '../views/flowSystem/CountTransitionSet.vue'
      // ),
      import(
        /*webpackChunkName:"CountTransitionSet" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/statis-config/unit-measurement/Setting.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '计量单位转换设置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
        {
          title: '计量单位转换',
          name: 'CountTransition',
        },
      ],
    },
  },
  //主规格转换设置
  {
    path: '/flowSystem/spec-trans',
    name: 'flowSystemSpecTrans',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOldHospitalSet" */
      //   '../views/flowSystem/SpecTrans'
      // ),
      import(
        /*webpackChunkName:"behaviorManageOldHospitalSet" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/statis-config/mainspecification-conversion/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      isMoreMeta: true,
      title: '主规格转换设置',
      breadcrumb: [
        {
          title: '系统设置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 报表中心设置
  // 报表中心模板配置
  {
    path: '/flowSystem/report-center-config',
    name: 'ReportCenterConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig1" */
      //   '../views/flowSystem/ReportCenterConfig.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig1" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/report-config/report-center--modal/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '报表中心设置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 报表中心设置  新增编辑
  {
    path: '/flowSystem/report-create-config/:id',
    name: 'ReportCreateConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig1" */
      //   '../views/flowSystem/ReportCreateConfig.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig1" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/report-config/report-center--modal/AddEdit.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '新增报表',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
        {
          title: '报表中心设置',
          name: 'ReportCenterConfig',
        },
      ],
    },
  },
  // 流向报表查看范围配置
  {
    path: '/flowSystem/flow-direction-config',
    name: 'FlowDirectionConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig1" */
      //   '../views/flowSystem/FlowDirectionConfig.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig1" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/report-config/flow-report-view/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '流向报表查看范围配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 流向数据查询配置
  {
    path: '/flowSystem/data-query-config',
    name: 'DataQueryConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig" */
      //   '../views/flowSystem/DataQueryConfig.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/data-quey-config/flow-data-query/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '流向数据查询配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 流向所属事业部-博瑞霖
  {
    path: '/flowSystem/borelin-flowAffiliated-business',
    name: 'BorelinFlowAffiliatedBusiness',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemConfig" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/borelin-flowAffiliated-business/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '流向所属事业部-博瑞霖',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 流向申诉配置
  {
    path: '/flowSystem/flow-appeal-config',
    name: 'FlowAppealConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig" */
      //   '../views/flowSystem/FlowAppealConfig.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/flow-statement-config/flow-satement/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '流向申诉配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 流向申诉配置  流向申诉审批设置
  {
    path: '/flowSystem/flow-appeal-setting',
    name: 'FlowAppealSetting',
    component: () =>
      // import(
      //   /*webpackChunkName:"agreementSetting" */
      //   '../views/flowSystem/FlowAppealSetting.vue'
      // ),
      import(
        /*webpackChunkName:"agreementSetting" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/flow-statement-config/flow-satement/AppealAet.vue'
      ),
    meta: {
      SecondaryMenu: '系统配置', //二级菜单
      title: '流向申诉审批配置',
      breadcrumb: [
        {
          title: '流向申诉配置',
          name: 'FlowAppealConfig',
        },
      ],
    },
  },

  // 流向申诉窗口期配置
  {
    path: '/flowSystem/flow-appeal-window-config',
    name: 'FlowAppealWindowConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig" */
      //   '../views/flowSystem/FlowAppealWindowConfig.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/flow-statement-config/state-window/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '流向申诉窗口期配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 历史月份流向配置
  {
    path: '/flowSystem/month-history-config',
    name: 'monthOfHistoryConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig1" */
      //   '../views/flowSystem/MonthOfHistoryConfig.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig1" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/history-flow/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '历史月份流向配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 固定规则设置
  {
    path: '/flowSystem/inherent-rules-config',
    name: 'inherentRulesConfig',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig2" */
      //   '../views/flowSystem/InherentRulesConfig.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig2" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/history-flow/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '固定规则设置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },
  // 库存周转天数预警值
  {
    path: '/flowSystem/inventory-edit-notice',
    name: 'inventoryEditNotice',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemConfig2" */
      //   '../views/flowSystem/InventoryEditNotice.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemConfig2" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/purchase-translate-day/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '库存周转天数预警值',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },


  
  // 库存周转天数预警值
  {
    path: '/flowSystem/periodic-statistics',
    name: 'periodicStatistics',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemConfig2" */
        '@/views/butterfly-flow-system/system-settings/system-setting/system-set/statis-config/periodic-statistics/Page.vue'
      ),
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '周期统计配置',
      breadcrumb: [
        {
          title: '系统配置',
          name: 'flowSystemConfig',
        },
      ],
    },
  },


]
export default systemSettingRouter
